export const environment = {
  prod: false,
  panel: 'admin',
  apiBaseUrl: 'https://hq-lawazm.adad.ws',
  filesApiUrl: 'https://hq-lawazm-file.adad.ws/AdminPanel/UploadFiles/',
};
